import WMS from './layers/WMS'
import MapStyle from './MapStyles'
import KML from './layers/KMLLayer'
import ApplicationConf from '../../conf/ApplicationConf'


const getLayer = (layer, popup, layerTypeTitle, url = '') => {
	if (layer && layer.type) {
		const color = layer.color ? layer.color : MapStyle.FILL_RED
		switch (layer.type) {
			case 'WMS' :
				return WMS({
					url: layer.url,
					params: { layers: layer.layer },
					opacity: layer.opacity,
					visibility: layer.visibility,
					popup: popup
				})
			case 'KML' :
				const urlKml = (() => {
					if (layer.url) {
						return layer.url
					}
					const layerValue = layer.value ? layer.value : ''
					return url ? url + layerValue : ApplicationConf.layer.cityLayer(layer.value)
				})()
				return KML({
					url: urlKml,
					style: color,
					headers: true,
					popup: popup,
					type: layerTypeTitle,
					extractStyles: layer.extractStyles
				})
			default:
				return null
		}
	}
	return null
}

const getKMLLayer = (layer) => {
	layer.type = 'KML'
	return getLayer(layer)
}
export { getLayer, getKMLLayer }



// WEBPACK FOOTER //
// ./src/utils/mapUtils/LayerUtils.js